const deployEnv: string = "Test";

export const CONST: { [key: string]: string } = {
  apiUrl:
    process.env.NODE_ENV === "development"
      ? "https://api.dev.quickpass.jp/v1/" //ローカル環境
      : deployEnv === "Test"
      ? "https://api.test.quickpass.jp/v1/" // テスト環境
      : deployEnv === "Production"
      ? "https://api.product.quickpass.jp/v1/" // 本番環境
      : "",
  cancellApiUrl:
    process.env.NODE_ENV === "development"
      ? "https://api.dev.quickpass.jp/cancell/" //ローカル環境
      : deployEnv === "Test"
      ? "https://api.test.quickpass.jp/cancell/" // テスト環境
      : deployEnv === "Production"
      ? "https://api.product.quickpass.jp/cancell/" // 本番環境
      : "",
  cancellApiKey:
    process.env.NODE_ENV === "development"
      ? "weklKz0tuxXVWMifOV5j9ynI3gkzjbd9yfIcK5Qi" //ローカル環境
      : deployEnv === "Test"
      ? "Np8MOFpdbT4cB7drQQXo19PHAd3ZL4Cs7Mxal2W6" // テスト環境
      : deployEnv === "Production"
      ? "uT8dOUaiOi9wRHyoKpORs5u8jL38X58B5gJuRqCg" // 本番環境
      : "",
  sbPaymentURL:
    process.env.NODE_ENV === "development"
      ? "https://stbfep.sps-system.com/f01/FepMrcInfoReceive.do" //ローカル環境
      : deployEnv === "Test"
      ? "https://stbfep.sps-system.com/f01/FepMrcInfoReceive.do" // テスト環境
      : deployEnv === "Production"
      ? "https://fep.sps-system.com/f01/FepMrcInfoReceive.do" // 本番環境
      : "",
};

export const headerColor: { [key: string]: string } = {
  green: "#cbecd4",
};

export const footerPDFTextColor: { [key: string]: string } = {
  green: "#6bb881",
};

export const footerBackGroundColor: { [key: string]: string } = {
  green: "#6bb881",
};

export const footerTextColor: { [key: string]: string } = {
  green: "white",
};
